















































































import Vue from "vue";
import { mapState } from "vuex";
export default Vue.extend({
  name: "designer-details",
  data() {
    return {
      viewMoreTextHint: false,
      quizBtn: {
        isDisabled: false,
        text: "Fill Project Details",
      },
    };
  },
  computed: {
    ...mapState("uiModule", {
      isOnMobileDevice: "isOnMobileDevice",
    }),
  },
  props: {
    details: {
      type: Object,
    },
    type: {
      type: String,
    },
    isCmAssigned: {
      type: Boolean,
    },
  },
  methods: {
    projectUpdate() {
      (this as any).$emit("updateProject");
    },
    collaboratorIsCalled() {
      let eventData = {
        eventName: "",
        properties: {
          designer_id: (this as any).details.id,
          phone: (this as any).details.phone,
        },
      };
      switch ((this as any).type) {
        case "designer":
          eventData.eventName = "DESIGNER_CALLED";
          break;
        case "bm":
          eventData.eventName = "BM_CALLED";
          break;
        case "cm":
          eventData.eventName = "CM_CALLED";
          break;
      }
      (this as any).$store.dispatch("appModule/trackSegementEvents", eventData);
    },
  },
});
